/* eslint-disable no-nested-ternary */
import { toast } from 'react-toastify';
import { Experience } from '@/webapi/use-experience-api';

export function formatAllocation(num: number): string {
  if (Number.isNaN(num) || num < 0) {
    return `0%`;
  }
  return `${num}%`;
}

export function handleInvalidAlloc(currentExperience: Experience) {
  const isInvalid =
    currentExperience.variants?.reduce((p, c) => p + c.chance, 0) > 100;
  if (isInvalid) {
    toast(`Variations must sum to 100%`, {
      theme: `colored`,
      type: `error`,
    });
  }
  return isInvalid;
}
